import { postReviewRequest, useGetRequsetableMeberships } from '#api/reviews';
// import { useDashboard } from '#providers/Dashboard';
import { useToast } from '#providers/ToastProvider';
import { PrevHeaderBarWithTitleTemplate } from '#templates';
import { useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';
import { ItemList } from './ItemList';
import { RequestButton } from './RequestButton';

export const ReviewRequestPage = () => {
  const [selectedMembership, setSelectedMembership] = useState<string[]>([]);

  const { showToast } = useToast();
  const queryClient = useQueryClient();

  // 안 쓰는 코드 주석 처리
  // const { customerDetail, confirmationFormIdProps } = useDashboard();

  // const { data } = useGetRequsetableMeberships(
  //   customerDetail.person ? customerDetail.person.id : ''
  // );
  const personId = sessionStorage.getItem('personId');
  const { data } = useGetRequsetableMeberships(personId ? personId : '');

  const onClick = async () => {
    try {
      await Promise.all(
        selectedMembership.map(membershipId => postReviewRequest(membershipId))
      );

      queryClient.invalidateQueries(['REQUESTABLEMEMBERSHIPS', personId]);
      showToast({
        type: 'success',
        message: '리뷰 요청이 완료되었습니다.'
      });
      setSelectedMembership([]);
    } catch (error) {
      showToast({
        type: 'fail',
        message: '리뷰 요청에 실패했습니다.'
      });
    }
  };

  return (
    <PrevHeaderBarWithTitleTemplate defaultBackground title={'리뷰 요청'}>
      <div className="px-20 py-28">
        <div className="text-[#bcb8c3] text-lg font-medium font-['Pretendard Variable'] leading-snug">
          회원님께 리뷰 요청을 <br />
          카카오톡 알림톡으로 보내드려요!
        </div>
        <div className="w-full h-28"></div>
        <ItemList
          data={data}
          selectedMembership={selectedMembership}
          setSelectedMembership={setSelectedMembership}
        />
      </div>
      <div className="w-full h-100"></div>
      <RequestButton
        onClick={onClick}
        disabled={selectedMembership.length === 0}
      />
    </PrevHeaderBarWithTitleTemplate>
  );
};
